import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import Api from '../../api';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

var GridServices =
/*#__PURE__*/
function () {
  function GridServices() {
    _classCallCheck(this, GridServices);
  }

  _createClass(GridServices, null, [{
    key: "get",
    value: function get(url, params, transformResult, transformFilter) {
      var query = {};

      if (transformFilter && params) {
        query = transformFilter(params);
      }

      return Api.get(url, query).pipe(map(function (result) {
        var response = result.response;

        if (transformResult) {
          return transformResult(response);
        }

        return response;
      }), catchError(function (err) {
        console.error(err);
        return throwError(err);
      }));
    }
    /**
     * Удаление записи
     * @param url
     */

  }, {
    key: "delete",
    value: function _delete(url) {
      return Api.delete(url);
    }
  }]);

  return GridServices;
}();

export { GridServices as default };